import { isEmpty } from "@/utils";
import { ManualOrderItem } from "./components/OrderItemForm/type";
import Big from "big.js";
import { Modal } from "antd";

/**
 * 计算手工订单实付金额
 * @param orderItems
 * @param shippingCost 运费
 * @param discounts 折扣
 * @returns
 */
export function isPaymentsLessZero(orderItems: ManualOrderItem[], shippingCost: number, discounts: number = 0) {
    let payments = new Big(0);
    let orderItemPrice = new Big(0);

    orderItems?.forEach(({ quantity, price }) => {
        if (!isEmpty(quantity) && !isEmpty(price)) {
            const numberPrice = Big(price);
            const numberQuantity = Big(quantity);

            if (!numberPrice.eq(0) && !numberQuantity.eq(0)) {
                const itemTotal = numberPrice.times(numberQuantity);
                orderItemPrice = orderItemPrice.plus(itemTotal);
                payments = payments.plus(itemTotal);
            }
        }
    });

    if (shippingCost) {
        payments = payments.plus(shippingCost);
    }

    payments = payments.minus(discounts);

    if (payments.lt(0)) {
        return {
            isLess: true,
            orderItemPrice: orderItemPrice.toNumber(),
            shippingCost,
            discounts,
            payments: payments.toNumber(),
        };
    }

    return {
        isLess: false,
        orderItemPrice: orderItemPrice.toNumber(),
        shippingCost,
        discounts,
        payments: payments.toNumber(),
    };
}

export function showPaymentsLessZeroModal(
    orderItemPrice: number,
    shippingCost: number,
    discounts: number,
    payments: number,
) {
    Modal.error({
        width: 580,
        title: "当前录入订单的实付=(订单商品金额+运费)-折扣<0，不支持保存。建议重新编辑，保证实付不小于0再保存",
        content: (
            <div className="error fb">
                <p>详细情况:</p>
                <p>订单商品金额:{orderItemPrice}</p>
                <p>运费:{shippingCost}</p>
                <p>折扣:{discounts}</p>
                <p>订单实付:{payments}</p>
            </div>
        ),
    });
}
